export const validationTranslations = {
  must_be_filled: 5949,
  must_be_equal: 7681,
  must_be_unique: 8105,
  validation_error: 7702,
  email_invalid: 7758,
  phone_number_invalid: 8287
};
